<template>
	<div>
			<ejs-circulargauge ref="circulargauge"
												 align="enter"
												 style="height:250px;"
												 :title="name"
												 background="transparent"
												 :titleStyle="titleStyle"
												 :enablePointerDrag="enablePointerDrag"
												 :tooltipRender="tooltipRender"
												 :dragEnd="dragEnd"
												 :tooltip="tooltip">
				<e-axes>
					<e-axis :radius="gaugeradius"
									:startAngle="startAngle"
									minimum=0
									maximum=60
									:endAngle="endAngle"
									:majorTicks="majorTicks"
									:lineStyle="lineStyle"
									:minorTicks="minorTicks"
									:annotations="annotations"
									:labelStyle="labelStyle"
									:ranges="ranges">
						<e-pointers>
							<e-pointer :value="value"
												 :cap="cap"
												 :pointerWidth="pointerWidth1"
												 :radius="pointerRadius"
												 :color="color"
												 :animation="animation">
							</e-pointer>
						</e-pointers>
					</e-axis>
				</e-axes>
			</ejs-circulargauge>
	</div>
</template>

<script>
import Vue from "vue";
import {CircularGaugePlugin, GaugeTooltip, Annotations } from "@syncfusion/ej2-vue-circulargauge";
Vue.use(CircularGaugePlugin);
export default Vue.extend({
	props: {
		name: {
			type: String,
			default: ''
		},
		value: {
			type: Number,
			default: 0
		}
	},
	data: function () {
		return {
			titleStyle: {
				size: "15px",
				color: "white"
			},
			pointerWidth1: 12,
			gaugeradius: "90%",
			startAngle: 240,
			endAngle: 120,
			lineStyle: {
				width: 0
			},
			majorTicks: {
				color: "white",
				offset: -3,
				height: 12,
				interval: 10,
			},
			minorTicks: {
				width: 0,
			},
			labelStyle: {
				useRangeColor: true,
				font: {
					color: "#424242",
					size: "12px",
					fontFamily: "Roboto"
				}
			},
			annotations: [
			{
				content: '',
				radius: '60%', angle: 180, zIndex:'1'
			},
			{
				content: '<div style="color:#24F900; font-size: 18px; font-family: Nunito Sans Bold">  ${pointers[0].value} °C</div>',
				radius: '80%', angle: 180, zIndex: '1'
			}
			],
			pointerRadius: "65%",
			color: "#B4F9A1",
			cap: {
				radius: 5,
				border: {
					color: "#B4F9A1",
					width: 2
				}
			},
			animation: {
				enable: true,
				duration: 1500
			},
			ranges: [{
				start: 0,
				end: 20,
				startWidth: 10,
				endWidth: 10,
				radius: "102%",
				color: "#30B32D", // "#B4F9A1",
			},{
				start: 20,
				end: 40,
				startWidth: 10,
				endWidth: 10,
				radius: "102%",
				color: "#F7E53B", // "#B4F9A1",
			}, {
				start: 40,
				end: 60,
				radius: "102%",
				startWidth: 10,
				endWidth: 10,
				color: "#FF774A",
			}],
			tooltip: {
				enable: true,
				type: ["Range", "Pointer"],
				enableAnimation: false
			},
			enablePointerDrag: true
		}
	},
	provide: {
		circulargauge: [GaugeTooltip, Annotations]
	},
	methods: {
		tooltipRender: function (args) {
			if (args.pointer) {
				args.tooltip.template = '<div id="templateWrap" style="border:2px solid #484E69;padding: 5px; background-color:#484E69"><div class="des" style="color:white"><span> ${value} °C</span></div></div>';
			}
		},
		dragEnd: function (args) {
			if (args.currentValue >= 0 && args.currentValue <= 20) {
				args.pointer.color = "#30B32D";
				args.pointer.cap.border.color = "#30B32D";
			} else if (args.currentValue > 20 && args.currentValue <= 40) {
				args.pointer.color = "#F7E53B";
				args.pointer.cap.border.color = "#F7E53B";
			}	else {
				args.pointer.color = "#FF774A"; //// color: ["#58E2C2", "#F7E53B", "#FF774A"],
				args.pointer.cap.border.color = "#FF774A";
			}
			this.$refs.circulargauge.setAnnotationValue(0, 0, `<div style="color:#B4F9A1; font-size: 18px; font-family: Nunito Sans Bold">  ${this.value} °C</div>`)
			args.pointer.value = args.currentValue;
			args.pointer.animation.enable = false;
			this.$refs.circulargauge.ej2Instances.refresh();
		}
	}
})
</script>

<style scoped>
#templateWrap img {
	border-radius: 30px;
	width: 30px;
	height: 30px;
	margin: 0 auto;
}

#templateWrap {
	background: #fff;
	padding: 3px;
	border-radius: 2px;
}

#templateWrap .des {
	float: right;
	padding-left: 10px;
	line-height: 30px;
}
</style>
